import { IReduxState } from 'types';
import { TRANSPARENT_OPTION } from 'pages/Batch/configs';

const getBatch = (state: IReduxState) => state.batch;
export const getBatchEraserItem = (state: IReduxState) => getBatch(state).eraserItem;
export const getBatchActiveTexture = (state: IReduxState) => getBatch(state).activeTexture;
export const getBatchActiveRgb = (state: IReduxState) => getBatch(state).activeColor;
export const getUserWatermarks = (state: IReduxState) => getBatch(state).userWatermarks;

export const getCropAlign = (state: IReduxState) => getBatch(state).cropAlign;
export const getCropOrientation = (state: IReduxState) => getBatch(state).cropOrientation;
export const getCropTemplate = (state: IReduxState) => getBatch(state).cropTemplate;
export const getCropAttrs = (state: IReduxState) => getBatch(state).cropAttrs;
export const getCropRotate = (state: IReduxState) => getBatch(state).cropRotate;
export const getCropFlip = (state: IReduxState) => getBatch(state).cropFlip;

export const getEnhanceIntensity = (state: IReduxState) => getBatch(state).enhanceIntensity;
export const getEnhanceMapping = (state: IReduxState) => getBatch(state).enhanceMapping;

export const getBatchActiveColor = (state: IReduxState) => {
  const activeRgb = getBatchActiveRgb(state);
  return activeRgb ? `rgb(${activeRgb.r}, ${activeRgb.g}, ${activeRgb.b})` : TRANSPARENT_OPTION;
};

export const getEnhanceBeforeAfter = (state: IReduxState) => state.batch.enhanceBeforeAfter;

export const getLatestAppliedTool = (state: IReduxState) => state.batch.latestAppliedTool;
export const getAppliedPremiumTools = (state: IReduxState) => state.batch.appliedPremiumTools;
export const getIsToolApplying = (state: IReduxState) => state.batch.isToolApplying;
